// Components==============
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/UI/Avatar/Avatar';
import ExpandMenuItem from 'components/UI/Communication/ExpendMenuItem/ExpendMenuItem';
import MessageList from 'components/UI/Communication/MessageList/MessageList';
import { useMediaQ } from 'hooks/useMediaQ';
import React, { useContext, useState } from 'react';
import { ProjectCommunicationContext } from '../../Communication';
import ProcesChats from '../ProcessChats/ProcesChats';
import './ChatList.module.scss';
// =========================

export default function ChatList() {
  const {
    directChannels,
    activeChannel,
    handleChannelChange,
    notifications,
    onlineUsers,
  } = useContext(ProjectCommunicationContext);

  const query = useMediaQ('min', 768);
  const [open, setOpen] = useState(false);

  return (
    <div
      styleName={`wrapper ${
        (activeChannel.image || activeChannel.member) && !open
          ? 'with-image'
          : ''
      }`}
      onClick={() => (!query ? setOpen((prev) => !prev) : null)}
    >
      {!query && !open && (
        <div styleName="mobile">
          {activeChannel?.name ? (
            <div styleName="channel">
              {activeChannel.member ? (
                <Avatar user={activeChannel.member} />
              ) : (
                <img src={activeChannel?.image} alt={activeChannel?.name} />
              )}
              <p>{activeChannel?.name}</p>
            </div>
          ) : (
            <p>Select channel</p>
          )}

          <FontAwesomeIcon
            styleName={`${open ? '' : 'rotated'}`}
            icon={faChevronUp}
          />
        </div>
      )}
      {(query || (!query && open)) && (
        <>
          <ExpandMenuItem title="Proces chats" component={<ProcesChats />} />
          {!!directChannels?.length && (
            <ExpandMenuItem
              hideArrow={!query}
              title="Directe berichten"
              component={
                <MessageList
                  list={directChannels}
                  onlineUsers={onlineUsers}
                  handleChannelChange={handleChannelChange}
                  activeChannel={activeChannel}
                  notifications={notifications}
                />
              }
            />
          )}
        </>
      )}
    </div>
  );
}
